import MenuItemPage from "./MenuItemPage";

export default MenuItemPage;
